module.exports = __webpack_public_path__ + "static/media/Chung Chi College_logo.d59947f0.png";